import { render, staticRenderFns } from "./SalesItems.vue?vue&type=template&id=bea82e92&scoped=true&"
import script from "./SalesItems.vue?vue&type=script&lang=js&"
export * from "./SalesItems.vue?vue&type=script&lang=js&"
import style0 from "./SalesItems.vue?vue&type=style&index=0&id=bea82e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea82e92",
  null
  
)

export default component.exports